"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AboutTheProduction() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-the-production" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <Card className="bg-muted-light border-none shadow-soft p-8 md:p-10">
              <h2 className="font-display text-3xl font-bold text-foreground md:text-4xl lg:text-5xl mb-6">
                About the Production
              </h2>
              <div className="space-y-4 text-foreground/90 leading-relaxed">
                <p className="text-base md:text-lg">
                  <span className="font-semibold">The Mass</span> is a
                  captivating production created by Philip Gray, delivering an
                  immersive storytelling experience that blends dramatic
                  performance with innovative visual design.
                </p>
                <p className="text-base md:text-lg">
                  Presented as a contemporary theatrical piece, the show
                  explores profound themes of identity, community, and
                  transformation through powerful acting, original music, and
                  striking stagecraft.
                </p>
                <p className="text-base md:text-lg">
                  Philip Gray's vision emphasizes emotional resonance and
                  audience engagement, inviting viewers to reflect on personal
                  and societal narratives. The production aims to attract
                  theater enthusiasts, cultural seekers, and supporters of
                  original art, positioning itself as a standout event in the
                  local performing‑arts scene.
                </p>
              </div>
            </Card>
          </div>

          {}
          <div ref={rightRef} className={`flex items-center justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${rightVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <div className="relative w-full max-w-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_c4tsq0f5.png" alt="About The Mass Production" className="w-full h-auto rounded-lg shadow-strong object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}